/* DEMO (29 Oct) homepage.
   1. Slideshow: moves the new slideshow (built from the Homepage slide entries in Shopify admin) in front of the old one, makes it advance every 6 seconds (the progress bar under it is the timer), pauses when the mouse is over it or a finger is on it, and lets people swipe or use the arrows and dots. No automatic movement if the visitor has asked their device to reduce motion.
   2. Our Best Sellers: a sideways row of product cards for the 12 best sellers in stock. The list is asked for fresh on every page view from the store (Shopify's own best-selling order, worked out from real orders), so it keeps itself up to date. The line under the title is the words in the <span class="dc-pnote"> below. */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  function hero() {
    var tpl = document.getElementById('dc-hero-tpl');
    var mast = document.getElementById('masthead');
    if (!tpl || !mast || !mast.parentNode) return;
    var node = tpl.content.firstElementChild.cloneNode(true);
    mast.parentNode.insertBefore(node, mast);
    var track = node.querySelector('.dc-hero-track');
    var slides = track.children, n = slides.length;
    var dots = Array.prototype.slice.call(node.querySelectorAll('.dc-hd'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0;
    if (n < 2) node.classList.add('dc-one');
    if (reduce) node.classList.add('dc-static');

    function mark(i) {
      idx = i;
      dots.forEach(function (d, k) {
        var on = k === i;
        if (on && !d.classList.contains('on')) { d.classList.add('on'); } else if (!on) { d.classList.remove('on'); }
        d.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
    function go(i) {
      i = (i + n) % n;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== idx) mark(i);
      }, 80);
    }, { passive: true });
    window.addEventListener('resize', function () { track.scrollLeft = idx * track.clientWidth; });
    node.querySelector('.dc-hprev').addEventListener('click', function () { go(idx - 1); });
    node.querySelector('.dc-hnext').addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });

    // the progress bar finishing = time for the next slide
    node.querySelector('.dc-hero-dots').addEventListener('animationend', function (e) {
      if (e.animationName === 'dcprog' && n > 1) go(idx + 1);
    });
    function pause(p) { node.classList.toggle('dc-paused', p); }
    node.addEventListener('mouseenter', function () { pause(true); });
    node.addEventListener('mouseleave', function () { pause(false); });
    node.addEventListener('focusin', function () { pause(true); });
    node.addEventListener('focusout', function () { pause(false); });
    node.addEventListener('touchstart', function () { pause(true); }, { passive: true });
    node.addEventListener('touchend', function () { setTimeout(function () { pause(false); }, 4000); }, { passive: true });
    document.addEventListener('visibilitychange', function () { pause(document.hidden); });
    mark(0);
  }

  function popular() {
    var anchor = document.getElementById('dc-hero') || document.getElementById('masthead');
    if (!anchor || !anchor.parentNode || !window.fetch) return;
    var sec = document.createElement('section');
    sec.id = 'dc-popular';
    sec.setAttribute('aria-label', 'Our best sellers');
    sec.hidden = true;
    sec.innerHTML = '<div class="dc-ph"><h2 class="dc-ptitle"><i class="fa fa-fire" aria-hidden="true"></i>Our Best Sellers</h2><span class="dc-pnote">What cafes and offices are buying right now</span></div>' +
      '<div class="dc-rw"><button type="button" class="dc-rnav dc-rprev" aria-label="Previous products" hidden>&#8249;</button><ul class="products-list"></ul><button type="button" class="dc-rnav dc-rnext" aria-label="More products" hidden>&#8250;</button></div>';
    anchor.parentNode.insertBefore(sec, anchor.nextSibling);

    fetch('/collections/all?sort_by=best-selling&view=dc-popular', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var ul = sec.querySelector('.products-list');
        ul.innerHTML = html;
        if (!ul.children.length) { sec.remove(); return; }
        sec.hidden = false;
        var pv = sec.querySelector('.dc-rprev'), nx = sec.querySelector('.dc-rnext');
        function arrows() {
          var max = ul.scrollWidth - ul.clientWidth;
          pv.hidden = ul.scrollLeft <= 2;
          nx.hidden = max <= 2 || ul.scrollLeft >= max - 2;
        }
        ul.addEventListener('scroll', arrows, { passive: true });
        window.addEventListener('resize', arrows);
        pv.addEventListener('click', function () { ul.scrollBy({ left: -ul.clientWidth * 0.9, behavior: 'smooth' }); });
        nx.addEventListener('click', function () { ul.scrollBy({ left: ul.clientWidth * 0.9, behavior: 'smooth' }); });
        arrows(); setTimeout(arrows, 400); setTimeout(arrows, 1500);
      })
      .catch(function () { sec.remove(); });
  }

  ready(function () { hero(); popular(); });
})();